import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndSummernote from '../common/form/labelAndSummernote';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';

import {
	setModoTela, initForm, getDadosMotoristaDataLake, enviarEmail, getListaEmails
} from './motoristaFolgaActions';

class MotoristaFolgaForm extends Component {

	state = {

	}

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown);
		this.atualizarDadosPrincipaisMotorista({ ...this.props.formularioValues });
	}
		
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyDown);
	}
	
	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setState({ ...this.state, registroModalEmail: null });
		}
	};

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard marginBottom={100}>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='id_motorista'
								component={Select}
								options={this.props.listaMotorista}
								label='Motorista'
								cols='12 7 8 9'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='placa'
								component={Select}
								options={this.props.listaPlaca.map(item => ({ id: item.placa, valor: item.placa }))}
								label='Placa'
								cols='12 5 4 3'
								placeholder='Selecione'
								readOnly={readOnly} />

							{/* CANCELADA e CONCLUÍDA*/}
							{(![4, 5].includes(this.props.formularioValues.id_estado) && this.props.formularioValues.dadosViagem) &&
							<Grid cols='12 12 12 12'>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										width: '100%',
										gap: 12,
										backgroundColor: '#f2f2f2',
										padding: 12,
										borderRadius: 4,
										marginBottom: 8
									}}
								>
									<div
										style={{
											flex: '0 0 240px',
											minWidth: 240
										}}
									>
										<p
											style={{
												margin: 0,
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap'
											}}
											title={this.props.formularioValues.dadosViagem.localizacao}
										>
											{this.props.formularioValues.dadosViagem.localizacao || '-'}
										</p>

										<p
											style={{
												margin: 0,
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap'
											}}
											title={this.props.formularioValues.dadosViagem.municipio}
										>
											{this.props.formularioValues.dadosViagem.municipio || '-'}
										</p>
									</div>


									<div
										style={{
											flex: '0 0 180px',
											minWidth: 180
										}}
									>
										<p style={{ margin: 0 }}><strong>Placa:</strong> {this.props.formularioValues.dadosViagem.placa || '-'}</p>
										<p style={{ margin: 0 }}><strong>Shipping:</strong> {this.props.formularioValues.dadosViagem.shipping || '-'}</p>
										<p style={{ margin: 0 }}><strong>Rumo:</strong> {this.props.formularioValues.dadosViagem.rumo || '-'}</p>
									</div>

									<div
										style={{
											flex: '1 1 320px',
											minWidth: 0
										}}
									>
										<p
											style={{
												margin: 0,
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap'
											}}
											title={this.props.formularioValues.dadosViagem.proxima_etapa}
										>
											<strong>Prox. Etapa:</strong> {this.props.formularioValues.dadosViagem.proxima_etapa || '-'}
										</p>

										<p
											style={{
												margin: 0,
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												whiteSpace: 'nowrap'
											}}
											title={this.props.formularioValues.dadosViagem.nome_etapa}
										>
											<strong>Local:</strong> {this.props.formularioValues.dadosViagem.nome_etapa || '-'}
										</p>

										<p style={{ margin: 0 }}>
											<strong>Previsão:</strong>{' '}
											{DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.dadosViagem.data_previsao_etapa) || '-'}
										</p>
									</div>

									<div
										style={{
											flex: '0 0 32px',
											display: 'flex',
											justifyContent: 'flex-end'
										}}
									>
										<button
											type="button"
											className="btn btn-secondary btn-xs"
											style={{
												width: 28,
												height: 28,
												borderRadius: 8,
												padding: 0
											}}
											title="Atualizar"
											onClick={() => this.atualizarDadosPrincipaisMotorista({ ...this.props.formularioValues })}
										>
											<i className="fas fa-sync-alt" />
										</button>
									</div>

								</div>
							</Grid>}

							<Field
								name='id_estado'
								component={Select}
								options={this.props.listaEstado}
								label='Estado'
								cols='12 4 4 4'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='id_tipo'
								component={Select}
								options={this.props.listaTipo}
								label='Tipo'
								cols='12 4 4 4'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='id_motivo'
								component={Select}
								options={this.props.listaMotivo}
								label='Motivo'
								cols='12 4 4 4'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='observacao'
								component={LabelAndTextarea}
								label='Observação' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<LabelAndInputDate
								label='Previsão Início'
								cols='12 6 4 4'
								value={this.props.formularioValues.data_planejamento_inicio}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_planejamento_inicio: value
									});
								}} />

							<LabelAndInputDate
								label='Início'
								cols='12 6 4 4'
								value={this.props.formularioValues.data_inicio}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_inicio: value
									});
								}} />

							<LabelAndInputDate
								label='Término'
								cols='12 6 4 4'
								value={this.props.formularioValues.data_termino}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										data_termino: value
									});
								}} />
						</Row>

						{this.controleTrocas(readOnly)}
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text={this.props.formularioValues.id ? 'Salvar' : 'Confirmar'}
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
	}

	controleTrocas(readOnly) {

		if (!this.props.formularioValues.id) {
			return null;
		}

		const trocas = this.props.formularioValues.trocas || [];

		const trocasLista = trocas.filter(item => !item.id || item.ativo);

		const possuiDevolucao = !!trocasLista.filter(item => item.id_tipo == 2).length;

		return (
			<>
				<hr />

				{this.modalEmail()}

				<Row>
					<Grid cols='6 1 1 1' style={{ minWidth: 210 }}>
						<button
							type='button'
							class={`btn btn-primary btn-block ${possuiDevolucao ? 'disabled' : ''}`}
							onClick={() => {
								if (!possuiDevolucao) {
									this.props.initForm({
										...this.props.formularioValues,
										trocas: this.ordenar([
											...trocas,
											{
												uuid: this.gerarUUID(),
												id_tipo: 1, //Substituição
												ordem: trocas.length + 1,
												leva: false
											}
										])
									});
								}
							}}>
							<i class='fa fa-plus'></i> Adicionar Substituição
						</button>
					</Grid>
					<Grid cols='6 1 1 1' style={{ minWidth: 210 }}>
						<button
							type='button'
							class={`btn btn-success btn-block ${possuiDevolucao ? 'disabled' : ''}`}
							onClick={() => {
								if (!possuiDevolucao) {

									let dataTermino = null;

									if (this.props.formularioValues.data_termino) {

										let data = new Date(this.props.formularioValues.data_termino);

										data.setDate(data.getDate() + 1);

										dataTermino = data.toISOString();

									}

									this.props.initForm({
										...this.props.formularioValues,
										trocas: this.ordenar([
											...trocas,
											{
												uuid: this.gerarUUID(),
												id_tipo: 2, //Devolução
												ordem: trocas.length + 1,
												leva: false,
												id_motorista: this.props.formularioValues.id_motorista,
												data_termino: dataTermino
											}
										])
									});
								}
							}}>
							<i class='fa fa-plus'></i> Adicionar Devolução
						</button>
					</Grid>
				</Row>

				<hr />

				{trocasLista.map((item, i) => {

					const possuiAnterior = i > 0;
					const possuiProximo = trocasLista[i+1] && trocasLista[i+1].id_tipo == 1;

					const quantidadeEmailsEnviados = this.props.listaEmails.filter(email => email.uuid_controle_troca == item.uuid).length;

					return (
						<div key={item.id || item.uuid}>
							<Row>
								{item.id_tipo == 2 && //Devolução
								<Grid
									cols='1 1 1 1'
									style={{
										maxWidth: 48,
										minWidth: 48,
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										gap: 4
									}}
								>
									<div 
										style={{
											width: 4,
											height: '100%',
											backgroundColor: '#28a745'
										}}>

									</div>
								</Grid>}
								{item.id_tipo == 1 && //Substituição
								<Grid
									cols='1 1 1 1'
									style={{
										maxWidth: 48,
										minWidth: 48,
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										gap: 4
									}}
								>
									<button
										type='button'
										className={`btn btn-${possuiAnterior ? 'secondary' : 'light'} btn-xs`}
										style={{
											width: 28,
											height: 28,
											borderRadius: 8,
											padding: 0
										}}
										title='Mover para cima'
										onClick={() => {
											if (possuiAnterior) {
												this.mover(i, 'up');
											}
										}}
									>
										<i className='fas fa-chevron-up' />
									</button>

									<div
										style={{
											borderRadius: 8,
											fontWeight: 700,
											color: '#495057',
											textAlign: 'center',
											marginLeft: 2
										}}
									>
										{item.ordem}
									</div>

									<button
										type='button'
										className={`btn btn-${possuiProximo ? 'secondary' : 'light'} btn-xs`}
										style={{
											width: 28,
											height: 28,
											borderRadius: 8,
											padding: 0
										}}
										title='Mover para baixo'
										onClick={() => {
											if (possuiProximo) {
												this.mover(i, 'down');
											}
										}}
									>
										<i className='fas fa-chevron-down' />
									</button>
								</Grid>}
								<Grid cols='10 10 10 10'>
									<Row>
										<Select
											options={this.props.listaMotorista}
											label='Motorista'
											cols='12 3 3 3'
											placeholder='Selecione'
											readOnly={item.id_tipo == 1 ? readOnly : 'readOnly'}
											value={item.id_motorista}
											onChange={value => {
												this.atualizarDadosMotorista({
													...item,
													id_motorista: value
												})
											}} />
										
										<Select
											options={this.props.listaLevas}
											label='Leva/Troca'
											cols='12 1 1 1'
											minWidth={90}
											naoLimpar
											placeholder='Selecione'
											readOnly={readOnly}
											value={item.leva ? 1 : 2}
											onChange={value => {
												this.alterarItem({
													...item,
													leva: value == 1
												})
											}} />
										
										<LabelAndInputDate
											label='Previsão Início'
											cols='12 6 4 4'
											value={item.data_previsao_inicio}
											onChange={value => {
												this.alterarItem({
													...item,
													data_previsao_inicio: value
												});
											}} />

											<LabelAndInputDate
											label='Início'
											cols='12 4 4 4'
											value={item.data_inicio}
											onChange={value => {
												this.alterarItem({
													...item,
													data_inicio: value
												});
											}} />
										
										<LabelAndInputDate
											label='Término'
											cols='12 4 4 4'
											value={item.data_termino}
											onChange={value => {
												this.alterarItem({
													...item,
													data_termino: value
												});
											}} />
										
										<Select
											options={this.props.listaEstadoTrocas}
											label='Estado'
											cols='12 3 3 3'
											placeholder='Selecione'
											readOnly={readOnly}
											value={item.id_estado}
											onChange={value => {
												this.alterarItem({
													...item,
													id_estado: value
												})
											}} />
										
										<Grid cols="7 7 7 7">
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													width: '100%',
													gap: 12,
													backgroundColor: '#f2f2f2',
													padding: 12,
													borderRadius: 4
												}}
											>

												{item.id_tipo === 1 && (
													<div
														style={{
															flex: '0 0 240px',
															minWidth: 240
														}}
													>
														<p
															style={{
																margin: 0,
																overflow: 'hidden',
																textOverflow: 'ellipsis',
																whiteSpace: 'nowrap'
															}}
															title={item.localizacao}
														>
															{item.localizacao || '-'}
														</p>

														<p
															style={{
																margin: 0,
																overflow: 'hidden',
																textOverflow: 'ellipsis',
																whiteSpace: 'nowrap'
															}}
															title={item.municipio}
														>
															{item.municipio || '-'}
														</p>
													</div>
												)}

												{item.id_tipo === 1 && (
													<div
														style={{
															flex: '0 0 180px',
															minWidth: 180
														}}
													>
														<p style={{ margin: 0 }}><strong>Placa:</strong> {item.placa || '-'}</p>
														<p style={{ margin: 0 }}><strong>Shipping:</strong> {item.shipping || '-'}</p>
														<p style={{ margin: 0 }}><strong>Rumo:</strong> {item.rumo || '-'}</p>
													</div>
												)}

												{item.id_tipo === 1 && (
													<div
														style={{
															flex: '1 1 320px',
															minWidth: 0
														}}
													>
														<p
															style={{
																margin: 0,
																overflow: 'hidden',
																textOverflow: 'ellipsis',
																whiteSpace: 'nowrap'
															}}
															title={item.proxima_etapa}
														>
															<strong>Prox. Etapa:</strong> {item.proxima_etapa || '-'}
														</p>

														<p
															style={{
																margin: 0,
																overflow: 'hidden',
																textOverflow: 'ellipsis',
																whiteSpace: 'nowrap'
															}}
															title={item.nome_etapa}
														>
															<strong>Local:</strong> {item.nome_etapa || '-'}
														</p>

														<p style={{ margin: 0 }}>
															<strong>Previsão:</strong>{' '}
															{DateFormat.formatarDataHoraSqlParaTela(item.data_previsao_etapa) || '-'}
														</p>
													</div>
												)}

												{item.id_tipo === 1 && 
												<div
													style={{
														flex: '0 0 32px',
														display: 'flex',
														justifyContent: 'flex-end'
													}}
												>
													<button
														type="button"
														className="btn btn-secondary btn-xs"
														style={{
															width: 28,
															height: 28,
															borderRadius: 8,
															padding: 0
														}}
														title="Atualizar"
														onClick={() => this.atualizarDadosMotorista({ ...item })}
													>
														<i className="fas fa-sync-alt" />
													</button>
												</div>}

											</div>
										</Grid>
										
										<LabelAndTextarea
											placeholder='Observação'
											cols='5 5 5 5'
											rows={3}
											value={item.observacao}
											onChange={data => {
												this.alterarItem({
													...item,
													observacao: data.target.value
												});
											}} />
									</Row>
								</Grid>								
								<Grid
									cols='1 1 1 1'
									style={{
										width: 48,
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										gap: 4
									}}
								>
									<a class='btn btn-app bg-danger' style={{ marginLeft: 2, minWidth: 75 }}
										onClick={() => {
											this.excluirItem({
												...item
											});
										}}>
										<i class='fas fa-trash'></i> Excluir
									</a>
									<a
										className={`btn btn-app bg-${quantidadeEmailsEnviados ? 'success' : 'secondary'}`}
										style={{
											marginLeft: 2,
											minWidth: 75,
											position: 'relative'
										}}
										onClick={() => {
											this.setRegistroModalEmail({
												...item,
												data_troca_email: item.data_previsao_inicio,
												assunto_email: 
													`Troca de Motorista - ${[
														...new Set([
															this.props.formularioValues.placa,
															item.placa
														].filter(placa => placa && placa.trim()))
													].join(', ')}`
											});
										}}
									>
										{quantidadeEmailsEnviados > 0 &&
											<span
												className='badge badge-light'
												style={{
													position: 'absolute',
													top: 3,
													right: 5,
													fontSize: 11,
													borderRadius: 10,
													padding: '3px 6px'
												}}
											>
												{quantidadeEmailsEnviados}
											</span>
										}

										<i className='fas fa-envelope'></i>

										{quantidadeEmailsEnviados
											? 'Enviado'
											: 'Pendente'
										}
									</a>
								</Grid>
							</Row>

							<hr />

						</div>
					)
				})}
			</>
		)
	}

	alterarItem(registro) {		
		this.props.initForm({
			...this.props.formularioValues,
			trocas: this.ordenar(this.props.formularioValues.trocas.map(item => {
				if ((item.id && item.id == registro.id) || (item.uuid && item.uuid == registro.uuid)) {
					return {
						...registro
					};
				}

				return item;
			}))
		});
	}
	
	excluirItem(registro) {

		let trocas = [];

		if (registro.id) {
			trocas = this.props.formularioValues.trocas.map(item => {
				if ((item.id && item.id == registro.id) || (item.uuid && item.uuid == registro.uuid)) {
					return {
						...registro,
						ativo: false
					};
				}

				return item;
			});
		} else {
			trocas = this.props.formularioValues.trocas.filter(item => {
				return item.uuid != registro.uuid;
			});
		}
		

		this.props.initForm({
			...this.props.formularioValues,
			trocas: this.ordenar(trocas)
		});
	}

	mover(posicao, direcao) {

		const listaCompleta = this.props.formularioValues.trocas || [];

		const trocasExcluidas = listaCompleta
			.filter(item => item.id && !item.ativo)
			.map(item => ({ ...item }));

		const trocasAtivas = listaCompleta
			.filter(item => !item.id || item.ativo)
			.map(item => ({ ...item }));

		let novaPosicao = posicao;

		if (direcao === 'up') {
			novaPosicao = posicao - 1;
		} else if (direcao === 'down') {
			novaPosicao = posicao + 1;
		} else {
			return;
		}

		// Impede movimentação para fora da lista
		if (
			novaPosicao < 0 ||
			novaPosicao >= trocasAtivas.length
		) {
			return;
		}

		// Troca as posições sem sobrescrever os valores
		[
			trocasAtivas[posicao],
			trocasAtivas[novaPosicao]
		] = [
			trocasAtivas[novaPosicao],
			trocasAtivas[posicao]
		];

		const trocasOrdenadas = this.ordenar(trocasAtivas);

		this.props.initForm({
			...this.props.formularioValues,
			trocas: [
				...trocasOrdenadas,
				...trocasExcluidas
			]
		});
	}

	ordenar(trocas) {

		let ordem = 0;

		return trocas.map(item => {

			if (!item.id || item.ativo) {
				ordem++;

				return {
					...item,
					ordem
				};
			}

			return {
				...item
			};
		});
	}

	atualizarDadosPrincipaisMotorista(registro) {
		
		const motorista = this.props.listaMotorista.filter(item => item.id == registro.id_motorista)[0];
 


		//CANCELADA e CONCLUÍDA
		if (motorista && ![4, 5].includes(registro.id_estado)) {
			this.props.getDadosMotoristaDataLake(motorista.valor, retorno => {

				const dados = retorno;				

				this.props.initForm({
					...this.props.formularioValues,	
					dadosViagem: {				
						localizacao: dados ? dados.localizacao : '',
						placa: dados ? dados.placa : '',
						proxima_etapa: dados ? dados.proxima_etapa : '',
						municipio: dados ? dados.municipio : '',
						shipping: dados ? dados.shipping : '',
						rumo: dados ? dados.rumo : '',
						nome_etapa: dados ? dados.nome_etapa : '',
						data_previsao_etapa: dados ? dados.data_previsao_etapa : ''
					}
				});

			});
		} else {

			this.props.initForm({
				...this.props.formularioValues,
				dadosViagem: {
					localizacao: null,
					placa: null,
					proxima_etapa: null,
					municipio: null,
					shipping: null,
					rumo: null,
					nome_etapa: null,
					data_previsao_etapa: null
				}
			});

		}
	}

	atualizarDadosMotorista(registro) {
		
		const motorista = this.props.listaMotorista.filter(item => item.id == registro.id_motorista)[0];
 
		if (motorista && registro.id_tipo == 1 && registro.id_estado != 3 && registro.id_estado != 4) { //Cancelada e Concluída
			this.props.getDadosMotoristaDataLake(motorista.valor, retorno => {

				const dados = retorno;

				this.props.initForm({
					...this.props.formularioValues,
					trocas: this.ordenar(this.props.formularioValues.trocas.map(item => {
						if ((item.id && item.id == registro.id) || (item.uuid && item.uuid == registro.uuid)) {
							return {
								...registro,
								localizacao: dados ? dados.localizacao : '',
								placa: dados ? dados.placa : '',
								proxima_etapa: dados ? dados.proxima_etapa : '',
								municipio: dados ? dados.municipio : '',
								shipping: dados ? dados.shipping : '',
								rumo: dados ? dados.rumo : '',
								nome_etapa: dados ? dados.nome_etapa : '',
								data_previsao_etapa: dados ? dados.data_previsao_etapa : ''
							};
						}

						return item;
					}))
				});

			});
		} else {

			this.props.initForm({
				...this.props.formularioValues,
				trocas: this.ordenar(this.props.formularioValues.trocas.map(item => {
					if ((item.id && item.id == registro.id) || (item.uuid && item.uuid == registro.uuid)) {
						return {
							...registro,
							localizacao: null,
							placa: null,
							proxima_etapa: null,
							municipio: null,
							shipping: null,
							rumo: null,
							nome_etapa: null,
							data_previsao_etapa: null
						};
					}

					return item;
				}))
			});

		}
	}

	escaparHtml(texto) {

		return String(texto || '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}

	negritoEmail(texto) {

		return `<strong>${this.escaparHtml(texto || '-')}</strong>`;
	}

	saudacaoEmail() {

		const hora = new Date().getHours();

		return hora < 12
			? 'Bom dia!'
			: 'Boa tarde!';
	}

	setRegistroModalEmail(registro) {

		if (registro && !registro.mensagem_editada) {

			const trocas =
				(this.props.formularioValues.trocas || [])
					.filter(item => !item.id || item.ativo);

			const motoristaOriginal =
				this.props.listaMotorista.find(
					item =>
						item.id ==
						this.props.formularioValues.id_motorista
				);

			const motoristaAtual =
				this.props.listaMotorista.find(
					item =>
						item.id ==
						registro.id_motorista
				);


			/*
			* Motorista anterior.
			*
			* Na primeira troca é o motorista original.
			* Nas demais é o motorista da troca anterior.
			*/
			let motoristaAnterior =
				motoristaOriginal;


			if (parseFloat(registro.ordem) > 1) {

				const trocaAnterior =
					trocas.find(
						item =>
							parseFloat(item.ordem) ==
							parseFloat(registro.ordem) - 1
					);

				if (trocaAnterior) {

					motoristaAnterior =
						this.props.listaMotorista.find(
							item =>
								item.id ==
								trocaAnterior.id_motorista
						);
				}
			}


			const nomeMotoristaAnterior =
				motoristaAnterior
					? motoristaAnterior.valor
					: '(Sem Motorista)';

			const nomeMotoristaAtual =
				motoristaAtual
					? motoristaAtual.valor
					: '(Sem Motorista)';


			/*
			* Prioriza a placa atual informada pelo Data Lake.
			*
			* Caso ainda não exista, usa a placa do registro pai.
			*/
			const placa =
				registro.placa ||
				this.props.formularioValues.placa ||
				'(Sem Placa)';


			const cidade =
				registro.nome_cidade_email ||
				'Sem Cidade';


			const dataInicio =
				DateFormat.formatarDataSqlParaTela(
					registro.data_inicio
				) ||
				'(Sem Data)';

			const dataTermino =
				DateFormat.formatarDataSqlParaTela(
					registro.data_termino
				) ||
				'(Sem Data)';

			const data =
				DateFormat.formatarDataSqlParaTela(
					registro.data_troca_email
				) ||
				'(Sem Data)';


			const rumo =
				registro.rumo || null;


			const saudacao =
				this.saudacaoEmail();


			let mensagemEmail = '';


			/*
			* =====================================================
			* LEVA
			* =====================================================
			*/
			if (registro.leva) {

				mensagemEmail =
					`${saudacao}<br/><br/>`
					+
					`Seguem os seguintes levas:<br/><br/>`
					+
					`${this.negritoEmail(cidade)}<br/>`
					+
					`${this.negritoEmail(placa)} - `
					+
					`Motorista ${this.negritoEmail(nomeMotoristaAtual)} `
					+
					`leva de ${cidade} até (Sem Cidade) na data ${data}.`;

				if (rumo) {

					mensagemEmail +=
						` Veículo carregado ${this.escaparHtml(rumo)}.`;
				}

			/*
			* =====================================================
			* TROCA
			* =====================================================
			*/
			} else {

				mensagemEmail =
					`${saudacao}<br/><br/>`
					+
					`Seguem as seguintes trocas:<br/><br/>`
					+
					`${this.negritoEmail(cidade)}<br/>`
					+
					`${this.negritoEmail(placa)} - `
					+
					`Sai o motorista ${this.negritoEmail(nomeMotoristaAnterior)} `
					+
					`e assume o motorista ${this.negritoEmail(nomeMotoristaAtual)} `
					+
					`na data de ${data}.`;

				if (rumo) {

					mensagemEmail +=
						`<br/>Veículo carregado ${this.escaparHtml(rumo)}.`;
				}
			}


			registro = {
				...registro,
				mensagem_email: mensagemEmail
			};
		}

		this.setState({
			registroModalEmail: registro
		});
	}

	modalEmail() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		if (!this.state.registroModalEmail) {
			return null;
		}

		const registro = this.state.registroModalEmail;

		const abaModalEmail =
			this.state.abaModalEmail || 'novo';

		const emailsEnviados =
			(this.props.listaEmails || []).filter(
				email =>
					email.uuid_controle_troca ==
					registro.uuid
			);

		return (
			<>
				<div
					className="modal-backdrop fade show"
					onClick={() =>
						this.setState({
							...this.state,
							registroModalEmail: null,
							abaModalEmail: 'novo'
						})
					}
				/>

				<div
					className="modal fade show"
					id="modal-md"
					style={{
						display: 'block'
					}}
					aria-modal="true"
					onMouseDown={() =>
						this.setState({
							...this.state,
							registroModalEmail: null,
							abaModalEmail: 'novo'
						})
					}
				>
					<div
						className='modal-dialog modal-lg'
						onMouseDown={e =>
							e.stopPropagation()
						}
					>
						<div className='modal-content'>

							{/* HEADER */}
							<div
								className='modal-header'
								style={{
									backgroundColor: '#1F3066',
									color: '#fff'
								}}
							>
								<h4 className='modal-title'>
									E-mail
								</h4>

								<button
									type='button'
									className='close custom-close'
									aria-label='Close'
									onClick={() =>
										this.setState({
											...this.state,
											registroModalEmail: null,
											abaModalEmail: 'novo'
										})
									}
								>
									<span
										aria-hidden='true'
										style={{
											color: '#fff',
											fontSize: 32,
											marginRight: 4
										}}
									>
										×
									</span>
								</button>
							</div>


							{/* ABAS */}
							<div
								style={{
									display: 'flex',
									backgroundColor: '#f8f9fa',
									borderBottom: '1px solid #dee2e6'
								}}
							>

								<div
									onClick={() =>
										this.setState({
											...this.state,
											abaModalEmail: 'novo'
										})
									}
									style={{
										padding: '12px 20px',
										cursor: 'pointer',
										fontWeight:
											abaModalEmail == 'novo'
												? 700
												: 400,
										color:
											abaModalEmail == 'novo'
												? '#1F3066'
												: '#6c757d',
										borderBottom:
											abaModalEmail == 'novo'
												? '3px solid #1F3066'
												: '3px solid transparent'
									}}
								>
									<i
										className='fas fa-pen-alt'
										style={{
											marginRight: 7
										}}
									/>

									Novo E-mail
								</div>


								<div
									onClick={() =>
										this.setState({
											...this.state,
											abaModalEmail: 'enviados'
										})
									}
									style={{
										padding: '12px 20px',
										cursor: 'pointer',
										fontWeight:
											abaModalEmail == 'enviados'
												? 700
												: 400,
										color:
											abaModalEmail == 'enviados'
												? '#1F3066'
												: '#6c757d',
										borderBottom:
											abaModalEmail == 'enviados'
												? '3px solid #1F3066'
												: '3px solid transparent'
									}}
								>
									<i
										className='fas fa-paper-plane'
										style={{
											marginRight: 7
										}}
									/>

									Enviados

									{emailsEnviados.length > 0 &&
										<span
											className='badge badge-success'
											style={{
												marginLeft: 7,
												borderRadius: 10,
												fontSize: 11
											}}
										>
											{emailsEnviados.length}
										</span>
									}
								</div>

							</div>


							{/* NOVO EMAIL */}
							{abaModalEmail == 'novo' &&
							<>
								<div
									className='modal-body'
									style={{
										padding: 20,
										overflowY: 'auto',
										maxHeight: '65vh'
									}}
								>
									<Row>

										<LabelAndInputDate
											label='Data da Troca'
											cols='12 12 12 12'
											value={
												registro.data_troca_email
											}
											onChange={value => {
												this.setRegistroModalEmail({
													...registro,
													data_troca_email:
														value
												});
											}}
										/>


										<Select
											options={
												this.props.listaCidadeTroca.filter(
													item =>
														item.utilizada ||
														registro.todas_cidades
												)
											}
											label='Cidade'
											cols='8 8 10 10'
											placeholder='Selecione'
											readOnly={readOnly}
											value={
												registro.id_cidade_email
											}
											onChange={value => {

												const cidade =
													this.props.listaCidadeTroca
														.filter(
															item =>
																item.id == value
														)[0];

												this.setRegistroModalEmail({
													...registro,

													id_cidade_email:
														value,

													nome_cidade_email:
														cidade
															? cidade.valor
															: null
												});
											}}
										/>


										<Grid
											cols='4 4 2 2'
											style={{
												paddingTop: 32
											}}
										>
											<ButtonTable
												type='primary'
												icon={
													registro.todas_cidades
														? 'fas fa-check-square'
														: 'fas fa-square'
												}
												visible={true}
												title='Todas as Cidades'
												event={() => {

													this.setRegistroModalEmail({
														...registro,

														todas_cidades:
															!registro.todas_cidades
													});
												}}
											/>
										</Grid>


										<Select
											options={
												this.props.listaGrupoEmail
											}
											label='Grupo'
											cols='12 12 12 12'
											placeholder='Selecione'
											readOnly={readOnly}
											value={
												registro.id_grupo_email
											}
											onChange={value => {

												const grupo =
													this.props.listaGrupoEmail
														.filter(
															item =>
																item.id == value
														)[0];

												this.setRegistroModalEmail({
													...registro,

													id_grupo_email:
														value,

													id_grupo_email_envio:
														grupo
															? grupo.id
															: null,

													emails_envio:
														grupo
															? grupo.emails
															: null
												});
											}}
										/>


										<LabelAndInput
											label='Assunto'
											cols='12 12 12 12'
											readOnly={readOnly}
											value={
												registro.assunto_email
											}
											onChange={data => {

												this.setRegistroModalEmail({
													...registro,

													assunto_email:
														data.target.value
												});
											}}
										/>


										<div className='form-group'>
											<label>Mensagem</label>

											<div
												contentEditable={!readOnly}
												suppressContentEditableWarning={true}
												style={{
													minHeight: 180,
													border: '1px solid #ced4da',
													borderRadius: 4,
													padding: 12,
													backgroundColor: readOnly ? '#e9ecef' : '#fff',
													outline: 'none'
												}}
												dangerouslySetInnerHTML={{
													__html: registro.mensagem_email || ''
												}}
												onBlur={event => {

													this.setRegistroModalEmail({
														...registro,

														mensagem_email:
															event.currentTarget.innerHTML,

														mensagem_editada:
															true
													});
												}}
											/>
										</div>

									</Row>
								</div>


								<div
									className='modal-footer'
									style={{
										justifyContent: 'center'
									}}
								>
									<Grid cols='12 12 12 12'>
										<Button
											text='Enviar E-mail'
											type='success'
											icon='fas fa-paper-plane'
											event={() =>
												this.props.enviarEmail(
													{
														id_motorista_folga: this.props.formularioValues.id,

														uuid_controle_troca:
															registro.uuid,

														id_cidade_selecionada:
															registro.id_cidade_email,

														id_grupo_email:
															registro.id_grupo_email_envio,

														emails:
															registro.emails_envio,

														assunto:
															registro.assunto_email,

														mensagem:
															registro.mensagem_email
													},
													() => {
														this.setRegistroModalEmail(
															null
														);
													}
												)
											}
										/>
									</Grid>
								</div>
							</>
							}


							{/* ENVIADOS */}
							{abaModalEmail == 'enviados' &&
							<div
								className='modal-body'
								style={{
									padding: 15,
									maxHeight: '65vh',
									overflowY: 'auto',
									backgroundColor: '#f4f6f9'
								}}
							>

								{emailsEnviados.length == 0 ? (

									<div
										style={{
											textAlign: 'center',
											padding: 40,
											color: '#6c757d'
										}}
									>
										<i
											className='fas fa-envelope-open'
											style={{
												fontSize: 38,
												marginBottom: 10,
												color: '#adb5bd'
											}}
										/>

										<div
											style={{
												fontWeight: 600
											}}
										>
											Nenhum e-mail enviado
										</div>

									</div>

								) : (

									emailsEnviados.map((email, indice) => (

										<div
											key={
												email.id ||
												indice
											}
											style={{
												backgroundColor: '#fff',
												border: '1px solid #dee2e6',
												borderRadius: 7,
												marginBottom: 12,
												overflow: 'hidden'
											}}
										>

											<div
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													padding: '10px 12px',
													backgroundColor: '#eef2f7',
													borderBottom: '1px solid #dee2e6'
												}}
											>

												<div
													style={{
														fontWeight: 700,
														color: '#1F3066'
													}}
												>
													<i
														className='fas fa-envelope'
														style={{
															marginRight: 7
														}}
													/>

													{email.assunto || 'Sem assunto'}
												</div>


												<div
													style={{
														fontSize: 12,
														color: '#6c757d'
													}}
												>
													<i
														className='far fa-clock'
														style={{
															marginRight: 5
														}}
													/>

													{email.datahora_envio
														? DateFormat.formatarDataHoraSqlParaTela(
															email.datahora_envio
														)
														: '-'
													}
												</div>

											</div>


											<div
												style={{
													padding: 12
												}}
											>

												<div
													style={{
														marginBottom: 8
													}}
												>
													<strong>
														Enviado por:
													</strong>
													{' '}
													{email.nome_usuario_envio || '-'}
												</div>


												<div
													style={{
														marginBottom: 10
													}}
												>
													<strong>
														Destinatários:
													</strong>

													<div
														style={{
															display: 'flex',
															flexWrap: 'wrap',
															gap: 5,
															marginTop: 5
														}}
													>

														{(email.emails || []).map(
															(itemEmail, i) => (

																<span
																	key={i}
																	className='badge badge-light'
																	style={{
																		border: '1px solid #ced4da',
																		padding: '5px 7px',
																		fontSize: 11
																	}}
																>
																	<i
																		className='fas fa-at'
																		style={{
																			marginRight: 4
																		}}
																	/>

																	{itemEmail}
																</span>

															)
														)}

													</div>
												</div>


												<div>
													<strong>
														Mensagem:
													</strong>

													<div
														contentEditable={false}
														suppressContentEditableWarning={true}
														style={{
															border: '1px solid #ced4da',
															borderRadius: 4,
															padding: 12,
															backgroundColor: readOnly ? '#e9ecef' : '#fff',
															outline: 'none'
														}}
														dangerouslySetInnerHTML={{
															__html: email.mensagem
														}}
													/>
												</div>

											</div>

										</div>

									))
								)}

							</div>
							}

						</div>
					</div>
				</div>
			</>
		);
	}

	gerarUUID() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
			const r = Math.random() * 16 | 0;
			const v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

}

MotoristaFolgaForm = reduxForm({ form: 'motoristaFolgaForm', destroyOnUnmount: false })(MotoristaFolgaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('motoristaFolgaForm')(state),
	registro: state.motoristaFolga.registro,
	listaMotorista: state.motoristaFolga.listaMotorista.filter(item => item.contrato_ativo),
	listaPlaca: state.motoristaFolga.listaPlaca,
	listaTipo: state.motoristaFolga.listaTipo,
	listaEstado: state.motoristaFolga.listaEstado,
	listaMotivo: state.motoristaFolgaMotivo.listaSelect,
	listaLevas: state.motoristaFolga.listaLevas,
	listaEstadoTrocas: state.motoristaFolga.listaEstadoTrocas,
	listaGrupoEmail: state.grupoEmail.listaSelect,
	listaCidadeTroca: state.motoristaFolga.listaCidadeTroca,
	listaEmails: state.motoristaFolga.listaEmails
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, getDadosMotoristaDataLake, enviarEmail, getListaEmails
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MotoristaFolgaForm);